import { createFileRoute } from '@tanstack/react-router'
import { CandidateDetail } from '@/features/linkedin-candidates/candidate-detail'

export const Route = createFileRoute(
  '/_authenticated/linkedin/candidates/$username/'
)({
  component: CandidateDetail,
})
